// extracted by mini-css-extract-plugin
module.exports = {"labelValue":"Options_labelValue__w982B","radios":"Options_radios__22eST"};